/**
 * @generated SignedSource<<94b8812fdef46b47cdce705815b861f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserAvatar_user$data = {
  readonly firstName: string;
  readonly lastName: string;
  readonly userUploads: {
    readonly nodes: ReadonlyArray<{
      readonly upload: {
        readonly url: string;
      } | null;
    }>;
  };
  readonly " $fragmentType": "UserAvatar_user";
};
export type UserAvatar_user$key = {
  readonly " $data"?: UserAvatar_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserAvatar_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": {
              "equalTo": "avatar"
            }
          }
        }
      ],
      "concreteType": "UserUploadsConnection",
      "kind": "LinkedField",
      "name": "userUploads",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserUpload",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Upload",
              "kind": "LinkedField",
              "name": "upload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "userUploads(filter:{\"name\":{\"equalTo\":\"avatar\"}})"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9973cf370e849e29594fd03bde04d14f";

export default node;
